<template>
  <svg
    width="338px"
    height="46px"
    viewBox="0 0 338 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Regional-app-logo"
        transform="translate(-186.000000, -442.000000)"
        fill-rule="nonzero"
      >
        <g id="Group-2" transform="translate(186.500000, 442.900000)">
          <path
            d="M302.2,16.7 C302.2,20.2 300.5,21.9 297,21.9 L291.8,21.9 L291.8,11.6 L297,11.6 C298.7,11.6 300,12.1 300.9,12.9 C301.7,13.8 302.2,15.1 302.2,16.7 M297.6,5.9 L287.6,5.9 C286.8,5.9 286.1,6.2 285.6,6.7 C285.1,7.2 284.8,7.9 284.8,8.7 L284.8,38.9 L291.7,38.9 L291.7,27.7 L297.2,27.7 C301,27.7 304,26.8 306.1,24.9 C308.2,23 309.2,20.3 309.2,16.8 C309.2,13.7 308.2,11 306.2,9 C304.2,6.9 301.3,5.9 297.6,5.9"
            id="Shape"
            fill="#FFFFFF"
          ></path>
          <path
            d="M269.9,24.9 L262,24.9 L265.9,13.3 L269.9,24.9 Z M265.9,5.7 C263.5,5.7 262,6.6 261.3,8.4 L250,38.8 L257.1,38.8 L259.9,30.7 L271.8,30.7 L274.5,38.7 L274.5,38.8 L281.7,38.8 L270.4,8.4 C269.9,6.6 268.4,5.7 265.9,5.7 L265.9,5.7 Z"
            id="Shape"
            fill="#FFFFFF"
          ></path>
          <path
            d="M330,16.7 C330,20.2 328.3,21.9 324.8,21.9 L319.5,21.9 L319.5,11.6 L324.7,11.6 C326.4,11.6 327.7,12.1 328.6,12.9 C329.6,13.8 330,15.1 330,16.7 M334,9 C332,7 329.2,5.9 325.5,5.9 L315.5,5.9 C314.7,5.9 314,6.2 313.5,6.7 C313,7.2 312.7,7.9 312.7,8.7 L312.7,38.9 L319.6,38.9 L319.6,27.7 L325.1,27.7 C328.9,27.7 331.9,26.8 334,24.9 C336.1,23 337.1,20.3 337.1,16.8 C337,13.6 336,11 334,9"
            id="Shape"
            fill="#FFFFFF"
          ></path>
          <rect
            id="Rectangle"
            fill="#000000"
            x="232.2"
            y="0"
            width="1.6"
            height="44.5"
          ></rect>
          <path
            d="M218.2,38.8 L218.2,36.2 L201.3,36.2 L201.3,5.8 L198.5,5.8 L198.5,37.2 C198.5,37.7 198.6,38 198.9,38.3 C199.2,38.6 199.6,38.7 200,38.7 L218.2,38.7 L218.2,38.8 Z M179.3,8.3 L185.6,25.2 L173,25.2 L179.3,8.3 Z M193.8,38.8 L181.8,7.6 C181.4,6.4 180.5,5.8 179.3,5.8 C178.1,5.8 177.2,6.4 176.8,7.6 L164.8,38.8 L167.9,38.8 L172.1,27.6 L186.5,27.6 L190.7,38.8 L193.8,38.8 Z M157.3,34.2 L138,6.9 C137.8,6.6 137.6,6.4 137.5,6.2 C137.4,6.1 137.2,5.9 136.9,5.8 C136.6,5.7 136.3,5.6 135.9,5.6 C135.4,5.6 135.1,5.7 134.8,5.9 C134.5,6.1 134.4,6.4 134.4,6.8 L134.4,38.7 L137,38.7 L137,10.1 L156.5,38.1 C157,38.8 157.6,39.1 158.4,39.1 C158.8,39.1 159.1,39 159.4,38.8 C159.7,38.6 159.8,38.3 159.8,38 L159.8,5.9 L157.2,5.9 L157.2,34.2 L157.3,34.2 Z M103.2,32.8 C100.9,30.2 99.7,26.7 99.7,22.3 C99.7,17.9 100.9,14.4 103.2,11.8 C105.5,9.2 108.6,7.9 112.3,7.9 C116,7.9 119,9.2 121.3,11.8 C123.6,14.4 124.8,17.9 124.8,22.3 C124.8,26.7 123.6,30.2 121.3,32.8 C119,35.4 116,36.7 112.3,36.7 C108.6,36.7 105.6,35.4 103.2,32.8 L103.2,32.8 Z M123.5,34.6 C126.3,31.5 127.7,27.4 127.7,22.3 C127.7,17.2 126.3,13.1 123.5,9.9 C120.7,6.8 117,5.2 112.4,5.2 C107.8,5.2 104.1,6.8 101.2,9.9 C98.4,13 96.9,17.2 96.9,22.3 C96.9,27.4 98.3,31.5 101.2,34.6 C104,37.7 107.8,39.3 112.4,39.3 C116.9,39.3 120.6,37.8 123.5,34.6 L123.5,34.6 Z M90.3,5.9 L87.5,5.9 L87.5,38.9 L90.3,38.9 L90.3,5.9 Z M76.9,35.3 C79.8,32.6 81.2,28.9 81.2,24.1 L81.2,21.9 L67.1,21.9 L67.1,24.4 L78.5,24.4 C78.4,28.2 77.3,31.2 74.9,33.4 C72.6,35.6 69.7,36.8 66.3,36.8 C62.7,36.8 59.7,35.5 57.4,32.9 C55.1,30.3 54,26.9 54,22.5 C54,18 55.2,14.4 57.6,11.8 C60,9.2 63.1,7.9 67.1,7.9 C69.5,7.9 71.6,8.4 73.4,9.5 C75.2,10.6 76.5,12 77.3,13.8 L79.8,12.6 C78.9,10.5 77.4,8.8 75.2,7.4 C73,6 70.3,5.3 67.1,5.3 C62.3,5.3 58.5,6.9 55.5,10.1 C52.5,13.3 51.1,17.5 51.1,22.7 C51.1,27.7 52.5,31.8 55.2,34.8 C58,37.9 61.6,39.4 66.3,39.4 C70.5,39.3 74.1,38 76.9,35.3 L76.9,35.3 Z M47.1,5.9 L29,5.9 C28.5,5.9 28.1,6 27.8,6.3 C27.5,6.6 27.3,7 27.3,7.5 L27.3,38.9 L46.8,38.9 L46.8,36.3 L30.1,36.3 L30.1,23.3 L45.7,23.3 L45.7,20.7 L30.1,20.7 L30.1,8.5 L47.1,8.5 L47.1,5.9 L47.1,5.9 Z M10,8.5 C12.6,8.5 14.5,9.1 15.8,10.3 C17.1,11.5 17.8,13.2 17.8,15.4 C17.8,17.7 17.1,19.4 15.7,20.6 C14.3,21.8 12.3,22.4 9.7,22.4 L2.7,22.4 L2.7,8.4 L10,8.4 L10,8.5 Z M21.1,38.8 L11.8,24.8 C14.6,24.5 16.8,23.5 18.4,21.9 C20,20.3 20.7,18.2 20.7,15.5 C20.7,12.5 19.8,10.1 18,8.4 C16.2,6.7 13.7,5.8 10.4,5.8 L1.5,5.8 C1.1,5.8 0.7,5.9 0.4,6.2 C0.1,6.5 0,6.9 0,7.3 L0,38.7 L2.8,38.7 L2.8,24.8 L8.7,24.8 L17.6,38.7 L21.1,38.7 L21.1,38.8 Z"
            id="Shape"
            fill="#000000"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white'
    }
  }
}
</script>
